import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface DraftState {
  step: number
  data: Record<string, unknown>
  setStep: (s: number) => void
  patch: (partial: Record<string, unknown>) => void
  clear: () => void
}

export const useRegistrationDraft = create<DraftState>()(
  persist(
    (set) => ({
      step: 0,
      data: {},
      setStep: (step) => set({ step }),
      patch: (partial) => set((s) => ({ data: { ...s.data, ...partial } })),
      clear: () => set({ step: 0, data: {} }),
    }),
    { name: 'cosmos-registration-draft', storage: createJSONStorage(() => sessionStorage) }
  )
)
